"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgListAltCircle(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0c6.626 0 12 5.374 12 12 0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12C0 5.373 5.372 0 12 0zm0 1.532C6.218 1.532 1.532 6.219 1.532 12c0 5.782 4.686 10.468 10.468 10.468 5.78 0 10.468-4.686 10.468-10.468C22.468 6.22 17.78 1.532 12 1.532zm5.257 5.21c.629 0 1.143.515 1.143 1.144v7.771c0 .629-.514 1.143-1.143 1.143H6.743A1.146 1.146 0 015.6 15.657V7.886c0-.629.514-1.143 1.143-1.143h10.514zm0 2.744H6.743a.235.235 0 00-.229.228v5.943c0 .122.107.229.229.229h10.514a.235.235 0 00.229-.229V9.714a.235.235 0 00-.229-.228zm-9.143 4.571c.122 0 .229.107.229.229v.457a.235.235 0 01-.229.228h-.457a.235.235 0 01-.228-.228v-.457c0-.122.107-.229.228-.229h.457zm8.229 0c.121 0 .228.107.228.229v.457a.235.235 0 01-.228.228H9.486a.235.235 0 01-.229-.228v-.457c0-.122.107-.229.229-.229h6.857zM8.114 12.23c.122 0 .229.107.229.228v.457a.235.235 0 01-.229.229h-.457a.235.235 0 01-.228-.229v-.457c0-.121.107-.228.228-.228h.457zm8.229 0c.121 0 .228.107.228.228v.457a.235.235 0 01-.228.229H9.486a.235.235 0 01-.229-.229v-.457c0-.121.107-.228.229-.228h6.857zM8.114 10.4c.122 0 .229.107.229.229v.457a.235.235 0 01-.229.228h-.457a.235.235 0 01-.228-.228v-.457c0-.122.107-.229.228-.229h.457zm8.229 0c.121 0 .228.107.228.229v.457a.235.235 0 01-.228.228H9.486a.235.235 0 01-.229-.228v-.457c0-.122.107-.229.229-.229h6.857z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgListAltCircle;
exports.default = _default;